import { useState } from "react";
import { faqs } from "@/pages/home/content";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section
      id="faq"
      className="w-full bg-background-100 py-12 md:py-16"
    >
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-semibold tracking-[0.3em] text-primary-700">
            FAQ
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            吃瓜FAQ
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            关于内容来源、核实流程与投稿规则，这里一次说清。
          </p>
        </div>

        <div className="mt-8 divide-y divide-background-300 rounded-2xl border border-background-200 bg-background-50">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <span className="font-heading text-base font-semibold text-foreground-950">
                    {f.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-foreground-800"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-sm`} />
                  </span>
                </button>
                {isOpen && (
                  <div className="animate-fadeUp px-5 pb-5 md:px-6">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}